module.exports = require("npm:@angular/compiler@2.0.0-rc.1/index.js");